import type { RadialHover } from './renderRadial';
import type { RadialPlot } from './types';

export type RadialTooltipProps = {
  plot: RadialPlot;
  hovered: RadialHover;
  format: (value: number) => string;
};

export const RadialTooltip = ({
  plot,
  hovered,
  format,
}: RadialTooltipProps) => {
  const series = plot.series[hovered.seriesIndex];
  const point = series?.points[hovered.pointIndex];
  if (!series || !point || point.value === null) return null;

  if (plot.angularAxis.kind === 'categorical') {
    return (
      <>
        <strong>{series.label}</strong>
        <div>
          {point.label}: {format(point.value)}
        </div>
      </>
    );
  }

  return (
    <>
      <strong>{point.label}</strong>
      <div>{series.label}</div>
      {point.angleValue !== null && (
        <div>
          {plot.angularAxis.title}: {format(point.angleValue)}
        </div>
      )}
      <div>
        {plot.radialTitle}: {format(point.value)}
      </div>
    </>
  );
};
